var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgGuestRulesGrTaskListPin = function SvgSvgGuestRulesGrTaskListPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.5H20a1 1 0 0 1 1 1v11.025a5.975 5.975 0 0 1-5.975 5.975H4a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1h8.5",
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.5H4a1 1 0 0 0-1 1v16c.003.219.08.43.218.6L20.6 5.718A.97.97 0 0 0 20 5.5Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10 16 3.5m2.5 2H20a1 1 0 0 1 1 1v11.025a5.975 5.975 0 0 1-5.975 5.975H4a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1h14.5Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#FF808C",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.912 18.5A5.946 5.946 0 0 1 16 23.41V19.5a1 1 0 0 1 1-1h3.912Z",
    fill: "#E3E3E3",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.5h5.5m9.422 0h-.01.01Zm-4.92 4.92v-.01.01ZM6 12.5h11H6Zm0 3h11H6Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSvgGuestRulesGrTaskListPin;